import dayjs, { Dayjs } from "dayjs";
import { ISODate } from "@/services/graphServices/getMessages";

export const toShortISOString = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

export const startOfMonth = (date: Date) => {
  const resultDate = new Date(date);
  resultDate.setDate(1);
  resultDate.setHours(0, 0, 0, 0);

  return resultDate;
};

export const dateFromYYYYMMDD = (stringDate: string) => {
  const dateArray = stringDate.split("-").map((period) => parseInt(period));
  return new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
};

export const toLongDateString = (date: Date | undefined, locale?: string) => {
  if (!date) {
    return undefined;
  }
  const longDate = date.toLocaleDateString(locale || "en-US", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  return longDate.charAt(0).toUpperCase() + longDate.slice(1);
};

export const dateFormatter = (stringDate: string | number | undefined) => {
  if (!stringDate) {
    return undefined;
  }
  const date =
    typeof stringDate === "string"
      ? dateFromYYYYMMDD(stringDate)
      : new Date(stringDate);
  return date.toLocaleDateString("no-NO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const toISOString = (
  date: Date | string | undefined,
  offsetDays = 0
): ISODate | undefined => {
  if (!date) {
    return undefined;
  }
  const d = dayjs(date).add(offsetDays, "day");
  const year = d.year();
  const month = d.month() + 1;
  const day = d.date();
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
    2,
    "0"
  )}` as ISODate;
};

export const dateToYYYYMMDD = (date: Date | Dayjs | undefined) => {
  if (!date) {
    return undefined;
  }
  const d = dayjs(date);
  return `${d.year()}-${String(d.month() + 1).padStart(2, "0")}-${String(
    d.date()
  ).padStart(2, "0")}`;
};

export const isDateInRange = (
  date: Date,
  startDate: Date | undefined,
  endDate: Date | undefined
) => {
  const dateTime = date.getTime();
  const isOlder = !startDate || dateTime >= startDate.getTime();
  const isYounger = !endDate || dateTime <= endDate.getTime();

  return isOlder && isYounger;
};
